import { QueryParameter } from '@deltasierra/frontend-routing-core';
import { isNullOrUndefined } from '@deltasierra/type-utilities';
import * as React from 'react';
import { ParsedTemplateId } from './use-template-id-state';

const LEGACY_BUILDER_PARAM_NAME = 'template';
const NEW_BUILDER_PARAM_NAME = QueryParameter.TemplateId;

function extractTemplateIdIdFromTemplateUrl(url: string): number | null {
    try {
        const urlObject = new URL(url);
        const queryParams = urlObject.searchParams;
        const path = urlObject.pathname;
        if (path !== '/contentBuilder' && path !== '/emailBuilder') {
            return null;
        }
        const templateId = queryParams.get(LEGACY_BUILDER_PARAM_NAME);
        if (isNullOrUndefined(templateId)) {
            return null;
        }
        const parsedTemplateId = parseInt(templateId, 10);
        if (isNaN(parsedTemplateId)) {
            return null;
        }
        return parsedTemplateId;
    } catch {
        return null;
    }
}

function extractBuildableTemplateIdFromTemplateUrl(url: string): string | null {
    const urlObject = new URL(url);
    const queryParams = urlObject.searchParams;
    const buildableTemplateId = queryParams.get(NEW_BUILDER_PARAM_NAME);
    if (isNullOrUndefined(buildableTemplateId)) {
        return null;
    }
    return buildableTemplateId;
}

function parseTemplateIdFromUrl(rawUrl: string): ParsedTemplateId {
    try {
        const url = rawUrl.trim();
        if (url === '') {
            return { type: 'empty' };
        }

        const templateId = extractTemplateIdIdFromTemplateUrl(url);
        if (templateId !== null) {
            return { id: templateId, type: 'builder-template' };
        }

        const buildableTemplateId = extractBuildableTemplateIdFromTemplateUrl(url);
        if (buildableTemplateId !== null) {
            return { id: buildableTemplateId, type: 'buildable-template' };
        }

        return {
            type: 'invalid',
        };
    } catch {
        return { type: 'invalid' };
    }
}

export function useTemplateIdFromUrl(url: string): ParsedTemplateId {
    return React.useMemo(() => parseTemplateIdFromUrl(url), [url]);
}
